import { render } from "./ImageViewer.vue?vue&type=template&id=5567e6cd"
import script from "./ImageViewer.vue?vue&type=script&lang=js"
export * from "./ImageViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ImageViewer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5567e6cd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5567e6cd', __exports__)) {
    api.reload('5567e6cd', __exports__)
  }
  
  module.hot.accept("./ImageViewer.vue?vue&type=template&id=5567e6cd", () => {
    api.rerender('5567e6cd', render)
  })

}


export default __exports__